/* global axios */
import ApiClient from './ApiClient';

class ConversationActivitiesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, params = {}) {
    return axios.get(`${this.url}/${conversationId}/activities`, { params });
  }

  show(conversationId, activityId) {
    return axios.get(`${this.url}/${conversationId}/activities/${activityId}`);
  }

  getStats(conversationId) {
    return axios.get(`${this.url}/${conversationId}/activities/stats`);
  }

  getByType(conversationId, activityType, params = {}) {
    return axios.get(`${this.url}/${conversationId}/activities/by_type`, {
      params: { activity_type: activityType, ...params }
    });
  }
}

export default new ConversationActivitiesAPI();
